import { object, mixed } from 'yup';

const schema = object().shape({
    asset: mixed().required(),
});

export default schema;
